export const setItem = (storage: Storage, key: string, value: any) =>
    storage.setItem(key, value)

export const getItem = (Storage: Storage, key: string) => Storage.getItem(key)
